<!-- Ported from vendor-ref/mara/app/ui/src/components/nanome/ComponentRow.vue (ToggleComponentsSelection -> store.toggleComponentsSelection, ZoomOnComponent -> store.zoomComponent) -->
<script setup lang="ts">
import Button from 'primevue/button';
import { useLiteStore, type Component } from '@nanome-lite/state';

const props = defineProps<{ component: Component; visualizationLabel: string }>();
const emit = defineEmits<{
  toggle: [serial: number, hidden: boolean];
  visualizations: [e: Event, component: Component];
  actions: [e: Event, component: Component];
}>();

const store = useLiteStore();

function onRowClick(e: MouseEvent) {
  if ((e.target as HTMLElement).closest('button')) return;
  store.toggleComponentsSelection([props.component.serial]);
}
</script>

<template>
  <div
    :data-selection="store.componentSelectionState([component.serial])"
    class="selectable-row flex items-center gap-2 pr-4 py-1"
    @click="onRowClick"
  >
    <Button
      :icon="component.hidden ? 'i-tabler-eye-off' : 'i-tabler-eye'"
      severity="secondary"
      size="small"
      rounded
      @click="emit('toggle', component.serial, !component.hidden)"
    />
    <span :title="component.name" :class="{ 'op-25': component.hidden }" class="mr-auto flex-1 truncate">
      {{ component.name }}
    </span>
    <div class="flex items-center gap-1">
      <Button
        :label="visualizationLabel"
        class="ml-auto"
        severity="secondary"
        size="small"
        rounded
        @click="emit('visualizations', $event, component)"
      />
      <Button
        v-tooltip.top="'Zoom'"
        icon="i-tabler-search"
        severity="secondary"
        size="small"
        rounded
        @click="store.zoomComponent(component.serial)"
      />
      <Button
        icon="i-tabler-dots"
        severity="secondary"
        size="small"
        rounded
        @click.prevent="emit('actions', $event, component)"
      />
    </div>
  </div>
</template>
